import Meemo from './Meemo'

export default Meemo
